/*

? First, let's import the interface that will describe the shape of our boost object.

*/

import StateInterface from "../state-interface";

export const ai_boosts: StateInterface["ai_boosts"] = {
	_id: "",
	property_id: "",
	property_slug: "",
	property_country: "",
	is_sales_support: false,
	lead_preferences: "qualified_including_qfr",
	start_date: new Date().toISOString(),
	end_date: new Date().toISOString(),
	trigger_start_date: new Date().toISOString(),
	trigger_end_date: new Date().toISOString(),
	status: "",
	package: "",
	expected_qualified_leads: 0,
	budget: {
		transaction_id: "",
		currency: "INR",
		total_budget: 0,
		amount_received: 0,
		platform_fees: 0,
		tax_details: {
			tax_name: "",
			tax_percentage: 0,
			tax_amount: 0,
		},
		meta_budget: 0,
		google_budget: 0,
		linkedin_budget: 0,
		manual_spend: {
			meta: 0,
			google: 0,
			add_meta_manual_spend_with_total: false,
			add_google_manual_spend_with_total: false,
		},
	},
	payment_mode: "",
	references: {
		creatives: [
			{
				file_id: "",
				mime_type: "",
				preview: "",
			},
		],
		logo: {
			file_id: "",
			mime_type: "",
			preview: "",
		},
		website_url: "",
		additional_notes: "",
	},
	client_details: {
		business_name: "",
		project_name: "",
		budget: "",
		contact_preferences: "",
		poc_name: "",
		poc_phone: {
			country_code: "",
			phone_number: "",
		},
		poc_email: "",
		poc_designation: "",
	},
	internal_checklist: {
		receipt_generated: false,
		kyc_verified: false,
		project_visited: false,
		landing_page_required: false,
		project_details_received: false,
		property_published_on_beegru: false,
		business_profile_completed: false,
		landing_page_completed: false,
		ad_creatives_created: false,
		campaign_created: false,
		landing_page_indexed: false,
		call_centre_briefed: false,
		property_marked_as_featured: false,
		broadcast_sent: false,
		ad_creatives_approved_by_client: false,
		ad_sets_and_lead_form_reviewed: false,
		ad_copies_reviewed: false,
		ad_creatives_uploaded: false,
		final_campaign_reviewed: false,
		verified_invoice: false,
	},
	ad_page_details: {
		page_name: "",
		page_id: "",
		access_token: "",
		intagram_account_id: "",
	},
	meta_ad_account_details: {
		ad_account_name: "",
		ad_account_id: "",
		owner_business_portfolio_id: "",
	},
	account_managed_by: {
		name: "",
		phone: {
			country_code: "",
			phone_number: "",
		},
		email: "",
		user_id: "",
	},
	pre_sales_poc: {
		name: "",
		phone: {
			country_code: "",
			phone_number: "",
		},
		email: "",
		user_id: "",
	},
	test: false,
	created_at: new Date().toISOString(),
	created_by: {
		is_business_profile: false,
		user_id: "",
		business_profile_id: "",
	},
	updated_at: new Date().toISOString(),
	cancelled: false,
	cancelled_at: new Date().toISOString(),
	deleted: false,
	deleted_at: new Date().toISOString(),
	optimization_runs_completed: 0,
	last_optimized_at: new Date().toISOString(),
	trigger_next_optimization_at: new Date().toISOString(),
	campaign_strategy: "",
	summary: "",
	internal_notes: "",
};
